import React, { useState, useMemo } from "react";
import { logoCandidates, APP_LOGO_REGISTRY } from "../lib/appLogos";

/**
 * AppLogo — renders the live logo for one of Stephen's sister apps.
 *
 * Tries the candidate URLs in order; each <img> onError event shifts to
 * the next URL. By the time we reach the final candidate (Google's
 * favicon proxy) we are guaranteed *something* to show.
 *
 * Owner ask: "I want all my actual app logos throughout my app — they're
 * on the live sites already, fetch them automatically."
 */
export default function AppLogo({ brandKey, size = 56, alt, rounded = true, glow = true }) {
  const candidates = useMemo(() => logoCandidates(brandKey), [brandKey]);
  const [idx, setIdx] = useState(0);
  const reg = APP_LOGO_REGISTRY[brandKey];
  if (!candidates.length) {
    // Brand isn't registered — render a soft placeholder so the layout
    // doesn't collapse.
    return (
      <div
        style={{
          width: size, height: size,
          borderRadius: rounded ? "50%" : 8,
          background: "rgba(255,184,0,0.12)",
          border: "1px solid rgba(255,184,0,0.4)",
        }}
      />
    );
  }
  const src = candidates[Math.min(idx, candidates.length - 1)];
  return (
    <img
      src={src}
      alt={alt || reg?.label || brandKey}
      width={size}
      height={size}
      data-testid={`app-logo-${brandKey}`}
      onError={() => setIdx((i) => i + 1)}
      referrerPolicy="no-referrer"
      style={{
        width: size,
        height: size,
        objectFit: "cover",
        borderRadius: rounded ? "50%" : 8,
        background: "#000",
        boxShadow: glow ? "0 0 14px rgba(255,184,0,0.45)" : "none",
        border: "1px solid rgba(255,184,0,0.5)",
        display: "block",
      }}
    />
  );
}
